import { render, staticRenderFns } from "./SuppliesWrhsdlvrStatus.vue?vue&type=template&id=1079d84a&scoped=true&"
import script from "./SuppliesWrhsdlvrStatus.vue?vue&type=script&lang=js&"
export * from "./SuppliesWrhsdlvrStatus.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesWrhsdlvrStatus.vue?vue&type=style&index=0&id=1079d84a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079d84a",
  null
  
)

export default component.exports